import {
  Color,
  DoubleSide,
  MeshPhysicalMaterial,
  MeshStandardMaterial,
} from "three";

export const glassMaterial: MeshStandardMaterial = _createGlassMaterial();
export const glassSideMaterial: MeshStandardMaterial =
  _createGlassSideMaterial();
export const glassInterMaterial: MeshStandardMaterial =
  _createGlassInterMaterial();

export const baseMaterial: MeshPhysicalMaterial = _createBaseMaterial();
export const kavcukMaterial: MeshPhysicalMaterial = _createKavcukMaterial();

function _createBaseMaterial(): MeshPhysicalMaterial {
  const material = new MeshPhysicalMaterial();
  material.color = new Color(0xdddddd);
  material.roughness = 0.1;
  material.metalness = 0.0;
  return material;
}

function _createKavcukMaterial(): MeshPhysicalMaterial {
  const material = new MeshPhysicalMaterial();
  material.color = new Color(0x111111);
  return material;
}

function _createGlassMaterial() {
  const material = new MeshStandardMaterial();

  //
  // material.reflectivity = 0;
  // material.transmission = 0.0;
  material.roughness = 0;
  material.metalness = 1;
  /*material.clearcoat = 1.0;
  material.clearcoatRoughness = 1;
  material.attenuationDistance = 0.5;
  material.attenuationColor = new Color(0xeeeeff);*/
  material.side = DoubleSide;
  material.color = new Color(0xffffff);
  //material.ior = 2;
  material.transparent = true;
  material.depthTest = true;
  material.depthWrite = true;
  material.opacity = 0.05;
  // material.thickness = 0.1;

  return material;
}

function _createGlassSideMaterial() {
  const material = new MeshStandardMaterial();

  material.roughness = 0;
  material.metalness = 1;

  material.side = DoubleSide;
  material.color = new Color(0x00ff00);
  //material.ior = 2;
  material.transparent = true;
  material.depthTest = true;
  material.depthWrite = true;
  material.opacity = 0.5;
  // material.thickness = 0.1;

  return material;
}

function _createGlassInterMaterial() {
  const material = new MeshStandardMaterial();
  material.roughness = 0;
  material.metalness = 1;
  material.side = DoubleSide;
  material.color = new Color(0xff0000);
  material.transparent = true;
  material.depthTest = true;
  material.depthWrite = true;
  material.opacity = 0.75;
  return material;
}
